import { Component } from '@angular/core';

@Component({
	selector: 'flx-auth-shell',
	templateUrl: './auth-shell.component.html',
	styleUrls: ['./auth-shell.component.scss']
})
export class FLXAuthShellComponent {}
